import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const DraggableColumnHeader = ({ id, children, ...props }) => {
    // Disable dragging for actions and status columns
    const isDraggable = id !== 'actions' && id !== 'ready_status';

    const { attributes, listeners, setNodeRef, transform, transition, isDragging, isOver } = useSortable({
        id,
        disabled: !isDraggable,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        cursor: isDraggable ? 'move' : 'default',
        opacity: isDragging ? 0.5 : 1,
        position: 'relative',
        zIndex: isDragging ? 1 : 0,
    };

    const dropTargetClass = isDraggable && isOver && !isDragging ? 'drop-target' : '';
    const mergedClassName = [props.className, dropTargetClass].filter(Boolean).join(' ');

    return (
        <th
            ref={setNodeRef}
            style={style}
            {...props}
            className={mergedClassName}
            {...(isDraggable ? attributes : {})}
            {...(isDraggable ? listeners : {})}
        >
            {children}
        </th>
    );
};
